import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { LineItemDisplayDetails as LineItemDisplayDetailsUnified } from './LineItemDisplayDetails'
import { LineItemDisplayDetailsLegacy } from './LineItemDisplayDetailsLegacy'
import type { LineItemDisplayDetailsProps } from './useLineItemDisplayDetailsModel'

export type { LineItemDisplayDetailsProps } from './useLineItemDisplayDetailsModel'

export const LineItemDisplayDetails: React.FC<LineItemDisplayDetailsProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS
  )

  return isUnifiedEnabled ? (
    <LineItemDisplayDetailsUnified {...props} />
  ) : (
    <LineItemDisplayDetailsLegacy {...props} />
  )
}
